import type { NiceNavigationItem } from "@recursyve/nice-ui-kit.v2";

export const adminNavigation: NiceNavigationItem[] = [
    {
        type: "divider"
    },
    {
        id: "formation",
        title: "navigation.formation",
        type: "collapsable",
        iconType: "svg",
        icon: "streamline-regular:book-library",
        children: [
            {
                id: "course",
                title: "navigation.course",
                type: "basic",
                link: "/dashboard/course"
            },
            {
                id: "enhancement-capsule",
                title: "navigation.enhancement_capsule",
                type: "basic",
                link: "/dashboard/enhancement-capsule"
            }
        ]
    },
    {
        id: "distributor",
        title: "navigation.distributor",
        type: "basic",
        iconType: "svg",
        icon: "streamline-regular:graduation-hat",
        link: "/dashboard/distributor"
    },
    {
        id: "supplier",
        title: "navigation.supplier",
        type: "basic",
        iconType: "svg",
        icon: "streamline-regular:online-learning-ar-education",
        link: "/dashboard/supplier"
    },
    {
        id: "organisation",
        title: "navigation.organisations",
        type: "basic",
        iconType: "svg",
        icon: "streamline-regular:building-1",
        link: "/dashboard/organisation"
    },
    {
        id: "promotion",
        title: "navigation.promotion",
        type: "basic",
        iconType: "svg",
        icon: "streamline-regular:tags",
        link: "/dashboard/promotion"
    },
    {
        id: "news",
        title: "navigation.news",
        type: "basic",
        iconType: "svg",
        icon: "streamline-regular:newspaper-fold-1",
        link: "/dashboard/news"
    },
    /* {
        id: "request",
        title: "navigation.request",
        type: "basic",
        iconType: "svg",
        icon: "streamline-regular:question-help-message",
        link: "/dashboard/request"
    }, */
    {
        id: "purchase-order",
        title: "navigation.purchase_order",
        type: "basic",
        iconType: "svg",
        icon: "streamline-regular:shopping-cart",
        link: "/dashboard/purchase-order"
    },
    {
        id: "member",
        title: "navigation.member",
        type: "basic",
        iconType: "svg",
        icon: "streamline-regular:multiple-actions-laptop",
        link: "/dashboard/member"
    },
    {
        id: "account",
        title: "navigation.user",
        type: "basic",
        iconType: "svg",
        icon: "streamline-regular:multiple-neutral-2",
        link: "/dashboard/account"
    },
    {
        id: "configuration",
        title: "navigation.configuration",
        type: "basic",
        iconType: "svg",
        icon: "streamline-regular:cog-double-2",
        link: "/dashboard/configuration"
    }
];
